import api from '../../base';
import { ORDERS_URL } from '../../orders';
import { Shipment } from './shipmentTypes';
import { mockShipments } from './shipmentMocks';

const BASE_PATH = `${ORDERS_URL}/shipments`;

// eslint-disable-next-line import/prefer-default-export
export async function getShipments(date: string, signal?: AbortSignal): Promise<Shipment[]> {
  const response = await api.get<Shipment[]>(`${BASE_PATH}/${date}`, { signal });

  return response.data;
}

api.mock
  .onGet(new RegExp(`${BASE_PATH}/.+`))
  .reply(200, mockShipments);
